const newArea = {
  snackbar: "Your update is ready",
  name: " Hazardous Area Classification Name",
  save: "Save",
  cancel: "Cancel",
  area: " Hazardous Area Classification",
  formTitle: "New Hazardous Area Classification",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete"
};
export default newArea;
